import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { combineReducers } from 'redux';

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_ARTICLE_SUCCESS]: (state, { payload }) =>
      Object.assign({}, state, { [payload.key]: payload })
  }
);

const setStatusForKey = (state, { type, payload }) =>
  Object.assign({}, state, { [payload.key]: type });

const status = createReducer(
  {},
  {
    [ActionTypes.FETCH_ARTICLES_REQUEST]: setStatusForKey,
    [ActionTypes.FETCH_ARTICLES_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_ARTICLES_ERROR]: setStatusForKey,
    [ActionTypes.FETCH_ARTICLE_REQUEST]: setStatusForKey,
    [ActionTypes.FETCH_ARTICLE_SUCCESS]: setStatusForKey,
    [ActionTypes.FETCH_ARTICLE_NOT_FOUND]: setStatusForKey,
    [ActionTypes.FETCH_ARTICLE_ERROR]: setStatusForKey
  }
);

const page = createReducer(0, {
  [ActionTypes.FETCH_ARTICLES_SUCCESS]: (state, { payload }) => payload.page
});
const perPage = createReducer(0, {
  [ActionTypes.FETCH_ARTICLES_SUCCESS]: (state, { payload }) => payload.perPage
});
const totalArticles = createReducer(0, {
  [ActionTypes.FETCH_ARTICLES_SUCCESS]: (state, { payload }) => payload.totalArticles
});
const params = createReducer(
  {},
  {
    [ActionTypes.FETCH_ARTICLES_REQUEST]: (state, { payload }) => payload.params || { ...state }
  }
);

export default combineReducers({
  list,
  status,
  page,
  perPage,
  params,
  totalArticles
});
